import Store from 'lightningjs-redux';
import { Lightning, Router } from '@lightningjs/sdk';
import { setCurrentLocation } from '../../logic/routing/routing.actions';
import { Page } from '../catalog/page.component';
import { Pairing } from '../pairing/pairing.component';
import { Landing } from '../landing/landing.component';
import { beforeEachRoute } from './hooks/beforeEachRoute.hook';
import { afterEachRoute } from './hooks/afterEachRoute.hook';
import {
  HOME_PATH,
  PAIRING_PATH,
  LANDING_PATH,
  PROFILE_PATH,
  EXPIRED_SUBSCRIPTION_PATH,
  SETTINGS_PATH,
  INFORMATION_PATH,
  FOLDERS_PATH,
  SERVICES_PATH,
  LIVES_PATH,
  USAGE_TERMS_PATH,
  PRIVACY_POLICY_PATH,
  LEGAL_CONDITIONS_PATH,
  ACCESSIBILITY_STATEMENT_PATH,
  FAQ_PATH,
  ACCOUNT_SETTINGS_PATH,
  FEEDBACK_PATH,
  DEVICE_GATE_PATH,
} from './routes.utils';
import { Account } from '../user/account/account.component';
import { Settings } from '../settings/settings.component';
import { StaticPage } from '../staticPage/staticPage.component';
import { SubscriptionExpired } from '../subscriptionExpired/subscriptionExpired.component';
import { QRCodePage } from '../qrCode/qrCode.component';
import { UserInformation } from '../user/userInformation/userInformation.component';
import { AbstractMosaic } from '../abstractMosaic/abstractMosaic.component';
import { Video } from '../video/video.component';
import { Live } from '../live/live.component';
import { routerConfig } from './platform/default';
import { routes as customerSpecificRoutes } from './customer/default/routes';
import { DeviceGate } from '../deviceGate/deviceGate.component';

class ErrorHandler extends Lightning.Component {
  _active() {
    Router.navigate('app/alias/home', false);
  }
}

export default {
  ...routerConfig,
  root: HOME_PATH,
  beforeEachRoute: (from, to) => {
    Store.dispatch(setCurrentLocation(to.url, to.route.path));
    // eslint-disable-next-line no-console
    console.log(`[routes] Navigating to: ${to.url}`);

    return beforeEachRoute(from, to);
  },
  afterEachRoute: destination => afterEachRoute(destination),
  routes: [
    ...customerSpecificRoutes,
    {
      path: 'video/:videoId',
      component: Video,
      widgets: ['CookieConsent', 'SnackBar', 'Popup', 'ScreenSaver'],
      options: {
        preventStorage: true,
        reuseInstance: false,
      },
    },
    {
      path: 'live/:videoId',
      component: Live,
      widgets: ['CookieConsent', 'SnackBar', 'Popup', 'ScreenSaver'],
      options: {
        preventStorage: true,
        reuseInstance: false,
      },
    },
    {
      path: 'app/:entityType/:entityId',
      component: Page,
      widgets: ['Sidenav', 'SnackBar', 'CookieConsent', 'Popup', 'ScreenSaver'],
      options: {
        reuseInstance: false,
      },
    },
    {
      path: 'app/frontspace/offers',
      component: SubscriptionExpired,
      widgets: ['CookieConsent', 'Popup', 'ScreenSaver'],
    },
    {
      path: PAIRING_PATH,
      component: Pairing,
      widgets: ['CookieConsent', 'Popup'],
    },
    {
      path: LANDING_PATH,
      component: Landing,
      widgets: ['CookieConsent', 'Popup'],
      options: {
        clearHistory: true,
      },
    },
    {
      path: DEVICE_GATE_PATH,
      component: DeviceGate,
      widgets: ['CookieConsent', 'Popup', 'ScreenSaver'],
      options: {
        clearHistory: true,
      },
    },
    {
      path: EXPIRED_SUBSCRIPTION_PATH,
      component: SubscriptionExpired,
      widgets: ['CookieConsent', 'SnackBar', 'Popup'],
    },
    {
      path: PROFILE_PATH,
      component: Account,
      widgets: ['Sidenav', 'CookieConsent', 'Popup', 'ScreenSaver'],
    },
    {
      path: SETTINGS_PATH,
      component: Settings,
      widgets: ['Sidenav', 'CookieConsent', 'Popup'],
    },
    {
      path: INFORMATION_PATH,
      component: UserInformation,
      widgets: ['Sidenav', 'CookieConsent', 'Popup'],
    },
    {
      path: FOLDERS_PATH,
      component: AbstractMosaic,
      widgets: ['Sidenav', 'CookieConsent', 'Popup', 'ScreenSaver'],
    },
    {
      path: SERVICES_PATH,
      component: AbstractMosaic,
      widgets: ['Sidenav', 'CookieConsent', 'Popup', 'ScreenSaver'],
    },
    {
      path: LIVES_PATH,
      component: AbstractMosaic,
      widgets: ['Sidenav', 'CookieConsent', 'Popup'],
    },
    {
      path: USAGE_TERMS_PATH,
      before: page => {
        page.target = 'termsOfUsage';

        return Promise.resolve();
      },
      component: StaticPage,
      widgets: ['CookieConsent', 'Popup'],
    },
    {
      path: LEGAL_CONDITIONS_PATH,
      before: page => {
        page.target = 'legalConditions';

        return Promise.resolve();
      },
      component: StaticPage,
      widgets: ['CookieConsent', 'Popup'],
    },
    {
      path: ACCESSIBILITY_STATEMENT_PATH,
      before: page => {
        page.target = 'accessibilityStatement';

        return Promise.resolve();
      },
      component: StaticPage,
      widgets: ['CookieConsent', 'Popup'],
    },
    {
      path: PRIVACY_POLICY_PATH,
      before: page => {
        page.target = 'privacyPolicy';

        return Promise.resolve();
      },
      component: StaticPage,
      widgets: ['CookieConsent', 'Popup'],
    },
    {
      path: FAQ_PATH,
      component: QRCodePage,
      widgets: ['Sidenav', 'Popup', 'ScreenSaver'],
    },
    {
      path: ACCOUNT_SETTINGS_PATH,
      component: QRCodePage,
      widgets: ['Sidenav', 'Popup', 'ScreenSaver'],
    },
    {
      path: FEEDBACK_PATH,
      component: QRCodePage,
      widgets: ['Sidenav', 'Popup', 'ScreenSaver'],
    },
    {
      path: '*',
      component: Page,
      widgets: ['CookieConsent', 'Popup'],
    },
    {
      path: '!',
      component: ErrorHandler,
    },
  ],
};
